import { fundChoices, holdsFundNumber } from '@/lib/practitioner'
import { cn } from '@/lib/utils'

// The client's health fund, picked where a receipt is issued and recorded on the
// client. Their receipts then print only that fund's provider number.

export const NO_FUND_LABEL = 'Not recorded — every number prints'

export function HealthFundSelect({
  funds,
  value,
  onChange,
  practitioner,
  disabled,
  className,
}: {
  /** The funds to offer; a recorded fund not among them is added so it can show. */
  funds: string[]
  value: string | null
  onChange: (fund: string | null) => void
  /** Whose numbers print — named when they hold no number with the chosen fund. */
  practitioner?: { name: string; funds: string[] } | null
  disabled?: boolean
  className?: string
}) {
  const options = fundChoices(funds, value)
  const unheld = practitioner && value && !holdsFundNumber(practitioner.funds, value)
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <select
        aria-label="Client's health fund"
        className="h-8 rounded-md border border-input bg-transparent px-2 text-[13px] text-foreground disabled:opacity-50"
        value={value ?? ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">{NO_FUND_LABEL}</option>
        {options.map((fund) => <option key={fund} value={fund}>{fund}</option>)}
      </select>
      <span className="text-[11.5px] text-muted-foreground">
        {unheld
          ? `${practitioner.name} holds no ${value} provider number — their other numbers print instead.`
          : value
            ? `Only the ${value} provider number prints. Recorded on the client for their next receipt too.`
            : 'Pick the fund they claim with and only its provider number prints.'}
      </span>
    </div>
  )
}
